import Loading from "@/core/components/globals/loading";
import Cookies from "js-cookie";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useEffect, useState } from "react";

export default function UnProtectedRoute({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const token = Cookies.get('accessToken');
    if (token) {
      navigate('/')
    } else {
      setIsLoading(false);
    }
  }, [pathname, navigate]);

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Loading />
      </div>
    );
  }

  return <>{children}</>;
}
